export default __webpack_public_path__ + "static/media/ConfamJara-0001.d843b659.png";